import { Routes } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { FehlerComponent } from './fehler/fehler.component';
import { authGuard } from './auth/auth-guard.service';
import { freigabeGuard } from './grundlagen/freigabe.guard';

export const BASIC_ROUTES: Routes = [
  {
    path: 'home',
    canActivate: [authGuard],
    component: HomeComponent,
    data: { title: 'Startseite' },
  },

  {
    path: 'login',
    loadComponent: async () => (await import('./auth/login/login.component')).LoginComponent,
  },
  {
    path: 'login/:logout',
    loadComponent: async () => (await import('./auth/login/login.component')).LoginComponent,
  },
  {
    path: 'logout',
    loadComponent: async () => (await import('./auth/logout/logout.component')).LogoutComponent,
  },
  {
    path: 'passwortanfordern',
    loadComponent: async () => (await import('./auth/passwortanfordern/passwortanfordern.component')).PasswortAnfordernComponent,
  },
  {
    path: 'anfordern/email',
    canActivate: [authGuard],
    loadComponent: async () => (await import('./auth/passwortanfordern/passwortanfordern.component')).PasswortAnfordernComponent,
  },
  {
    path: 'passwortneu',
    loadComponent: async () => (await import('./auth/passwortneu/passwortneu.component')).PasswortneuComponent,
  },
  {
    path: 'loginWVA',
    loadComponent: async () => (await import('./auth/login-wva/login-wva.component')).LoginWVAComponent,
  },
  {
    path: 'fehler',
    loadComponent: async () => (await import('./fehler/fehler.component')).FehlerComponent,
  },
  {
    path: 'popup',
    loadComponent: async () => (await import('./shared/ui/popup/ui-popup.component')).uiPopupComponent,
  },

  // Untermenüs – freigabeGuard prüft alle Unterseiten gegen FREIGABE_REGELN
  {
    path: 'stammdaten',
    canActivate: [authGuard],
    canActivateChild: [freigabeGuard],
    loadChildren: async () => (await import('./anwendung/stammdaten/stammdaten.routes')).STAMMDATEN_ROUTES,
  },
  {
    path: 'artikel',
    canActivate: [authGuard],
    canActivateChild: [freigabeGuard],
    loadChildren: async () => (await import('./anwendung/artikel/artikel.routes')).ARTIKEL_ROUTES,
  },
  {
    path: 'auswertungen',
    canActivate: [authGuard],
    canActivateChild: [freigabeGuard],
    loadChildren: async () => (await import('./anwendung/auswertungen/auswertungen.routes')).AUSWERTUNGEN_ROUTES,
  },
  {
    path: 'system',
    canActivate: [authGuard],
    canActivateChild: [freigabeGuard],
    loadChildren: async () => (await import('./anwendung/system/system.routes')).SYSTEM_ROUTES,
  },
  {
    path: 'hilfe',
    canActivate: [authGuard],
    canActivateChild: [freigabeGuard],
    loadChildren: async () => (await import('./anwendung/hilfe/hilfe.routes')).HILFE_ROUTES,
  },
  {
    path: 'portal',
    canActivate: [authGuard],
    canActivateChild: [freigabeGuard],
    loadChildren: async () => (await import('./anwendung/portal/portal.route')).PORTAL_ROUTES,
  },
  {
    path: 'bestellungen',
    canActivate: [authGuard],
    canActivateChild: [freigabeGuard],
    loadChildren: async () => (await import('./anwendung/bestellungen/bestellungen.route')).PORTAL_ROUTES,
  },

  // Default
  { path: '', redirectTo: 'home', pathMatch: 'full' },
  { path: '**', canActivate: [authGuard], component: FehlerComponent },
];
